module.exports = __webpack_public_path__ + "img/allowances-daily-plans.f24cdb5b.svg";